import { useState } from "react";

/** Snapshot the site default once per draft; refetches cannot change a draft. */
type DraftProcedureSelectionOptions = {
  open: boolean;
  draftKey: string;
  data: { defaultProcedureId?: string | null } | undefined;
};

export function useDraftProcedureSelection({
  open,
  draftKey,
  data,
}: DraftProcedureSelectionOptions) {
  const initial = () => ({
    open,
    draftKey,
    initialized: Boolean(open && data),
    value: open ? (data?.defaultProcedureId ?? "NONE") : "NONE",
    initialValue: open ? (data?.defaultProcedureId ?? "NONE") : "NONE",
  });
  const [selection, setSelection] = useState(initial);
  let current = selection;
  if (selection.open !== open || selection.draftKey !== draftKey) {
    current = initial();
    setSelection(current);
  } else if (open && !selection.initialized && data) {
    current = {
      ...selection,
      initialized: true,
      value: data.defaultProcedureId ?? "NONE",
      initialValue: data.defaultProcedureId ?? "NONE",
    };
    setSelection(current);
  }
  return {
    procedure: current.value,
    hasProcedureChanges: current.value !== current.initialValue,
    setProcedure: (value: string) =>
      setSelection({ ...current, value, initialized: true }),
    resetProcedure: () => setSelection(initial()),
  };
}
